
interface ReferentialStatus {
    [key: string]: { id: string }
}

export const REFERENTIAL_STATUS: ReferentialStatus = {
    INACTIVE: {id: "INACTIVE"},
    ACTIVE: {id: "ACTIVE"}
}
